export default __webpack_public_path__ + "static/media/arahuana.75ea2335.jpg";